// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_jg-0";
export var animationContainer = "_jg-1";
export var itemPrice = "_jg-a";
export var itemizedContent = "_jg-9";
export var itemizedHeader = "_jg-7";
export var itemizedRow = "_jg-8";
export var itemizedSection = "_jg-6";
export var modalContent = "_jg-2";
export var orderName = "_jg-3";
export var refundOption = "_jg-4";
export var refundOptionsContainer = "_jg-5";
export var shippingLabel = "_jg-b";
export var totalRow = "_jg-c";